import { makeStyles } from '@material-ui/core';
import { Colors } from '../../utils';

const makeClasses = makeStyles((theme) => ({
  dialog: {
    boxShadow: 'none',
    width: '65%',
    maxWidth: '65%',
    minHeight: 500,

    [theme.breakpoints.down('sm')]: {
      width: '95%',
      maxWidth: '95%',
      margin: 0,
      minHeight: '50%',
    },
  },
  dialogTitleWrapper: {
    background: Colors.rgb.black_light,
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,

    '& > h2': {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
  },
  dialogTitle: {
    fontFamily: theme.fontFamily.light,
    fontSize: theme.fontSize.XL,
    color: Colors.rgb.white,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontSize: theme.fontSize.M,
    },
  },
  dialogTitleWithCloseButton: {
    [theme.breakpoints.down('sm')]: {
      width: '85%',
    },
  },
  dialogTitleClose: {
    position: 'absolute',
    right: 0,
    height: 23,
    cursor: 'pointer',
  },
  dialogTitleCloseIcon: {
    color: Colors.rgb.white,
  },
  dialogContentWrapper: {
    backgroundColor: Colors.rgb.page_background,
    padding: theme.spacing(4),
  },
  plansWrapper: {
    boxShadow: 'none',
    marginBottom: theme.spacing(2),

    '&:before': {
      content: 'none',
    },
  },
  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(4),
  },
  accordionSummaryExpanded: {
    marginTop: '0 !important',
    marginBottom: '0 !important',
    minHeight: 'fit-content !important',
  },
  plansLinesAccordion: {
    borderTop: `1px solid`,
    borderColor: Colors.rgb.gray,
    background: Colors.rgb.white,
    padding: theme.spacing(2),
  },
  accordionContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  coefficientContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  field: {
    padding: theme.spacing(2),
    color: Colors.rgb.contentText,
    backgroundColor: Colors.rgb.light_gray,
    borderBottom: `1px solid ${Colors.rgb.gray}`,
    fontSize: theme.fontSize.S,
  },
  plansGroupTitle: {
    marginBottom: theme.spacing(2)
  },
  plansGroupLine: {
    fontWeight: 'bold',
    color: Colors.rgb.dark_gray,
  },
  plansGroupItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  plansGroupName: {
    display: 'flex',
    flexDirection: 'column'
  },
  plansPlan712AdditionalsTitle: {
    fontWeight: 'bold',
  },
  disclaimerText: {
    fontSize: theme.fontSize.XS,
    color: Colors.rgb.medium_gray,
    padding: theme.spacing(2)
  }
}));

export default makeClasses;
